import { ReactComponent as TrashIcon } from "../../../../assets/trashIcon.svg";
import { ReactComponent as CheckIcon } from "../../../../assets/checkIcon.svg";
import { OptionModel } from "../../../../modules/createCampaign/models/questionModel";
import lightOrDarkColor from "@check-light-or-dark/color";
import "./multipleChooseOption.scss";
import { useState } from "react";

export default function MultipleChooseOption(props: {
  isEditable?: boolean;
  viewOnly?: boolean;
  placeholder?: string;
  onChange?: (e: OptionModel) => void;
  initialValue?: OptionModel;
  value?: string;
  isFocused?: boolean;
  maxWidth?: string;
  onClickDelete?: () => void;
  children?: any;
  onClick?: () => void;
  isSelected?: boolean;
  border?: string;
  padding?: string;
  color?: string;
  fontFamily?: string;
}) {
  const [inputValue, setInputValue] = useState(props.initialValue?.option);
  const [inputScore, setScoreValue] = useState(props.initialValue?.score);
  return (
    <div
      className="multiple-choose-option-outer-container"
      style={{
        borderRadius: props.children && props.isSelected && "0.5rem 0.5rem 0 0",
        maxWidth:
          props.isEditable == false || props.viewOnly == true
            ? props.maxWidth
            : `calc(${props.maxWidth} + 0.5rem + 18px)`,
      }}
    >
      <div
        className="multiple-choose-option-container"
        onClick={props.onClick}
        style={{ cursor: props.onClick ? "pointer" : "" }}
      >
        <div
          className="multiple-choose-option"
          style={{
            border: props.border,
            padding: props.padding,
          }}
        >
          <div
            className={`multiple-choose-box ${
              props.isSelected && "multiple-choose-box-selected"
            }`}
            style={{
              border: props.border,
              backgroundColor: props.isSelected ? props.color : undefined,
            }}
          >
            {props.isSelected && (
              <CheckIcon
                height={10}
                width={10}
                stroke={
                  lightOrDarkColor(props.color ?? "") === "light"
                    ? "black"
                    : "white"
                }
              />
            )}
          </div>
          <input
            className={"multiple-choose-input"}
            onClick={props.onClick}
            style={{
              cursor: props.onClick ? "pointer" : "",
              color: props.color,
              fontFamily: props.fontFamily,
            }}
            disabled={props.viewOnly == true}
            placeholder={props.placeholder}
            onChange={(e) => {
              setInputValue(e.target.value);
              props.onChange?.({
                option: e.target.value,
                score: props.initialValue?.score ?? undefined,
              });
            }}
            value={props.value ?? inputValue ?? ""}
            autoFocus={props.isFocused}
          />
          {props.isEditable != false && props.viewOnly != true && (
            <div className="multiple-choose-score-container">
              Score:
              <input
                className={"multiple-choose-score-input"}
                onChange={(e) => {
                  let x = !isNaN(parseInt(e.target.value))
                    ? parseInt(e.target.value)
                    : undefined;
                  setScoreValue(x);
                  props.onChange?.({
                    option: props.initialValue?.option ?? "",
                    score: x,
                  });
                }}
                value={inputScore ?? ""}
              />
            </div>
          )}
        </div>
        {props.isEditable != false && props.viewOnly != true && (
          <TrashIcon
            width={20}
            height={20}
            stroke={"black"}
            style={{ cursor: "pointer" }}
            onClick={props.onClickDelete}
          />
        )}
      </div>
      {props.children && props.isSelected && (
        <div className="multiple-choose-option-children">{props.children}</div>
      )}
    </div>
  );
}
